import { clsx } from 'clsx';
import { STATUS_COLORS } from '../../utils/constants';

interface BadgeProps {
  status: keyof typeof STATUS_COLORS;
  children: React.ReactNode;
}

export function Badge({ status, children }: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        STATUS_COLORS[status]
      )}
    >
      {children}
    </span>
  );
}
